<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container style="width: 100%;">
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout>
                <v-flex xs12 sm6>
                    <div>
                        <v-btn class="no-print" @click="newCriterioMusculoCf" large color="primary">Nueva hoja</v-btn>
                    </div>
                </v-flex>
            </v-layout>
            <br>
            <br>
            <v-layout>
                <v-flex xs12 sm6 offset-sm1>
                    <v-select
                            v-model="criterioFinalMusculo"
                            :items="listCriterioMusculoCf"
                            label="Historial"
                            item-text="fecha"
                            return-object
                            required
                    ></v-select>
                </v-flex>
            </v-layout>
                    <div v-if="criterioFinalMusculo!=null">
                        <div>Criterios Finales</div>
                    <v-layout>
                        <v-flex xs16 sm14 offset-sm1>
                            <div v-for="item in criterioFinalMusculo.lista" v-bind:key="item">
                                {{item.title}}

                                <table style="width:100%" border="1">
                                    <tr>
                                        <th>CONCLUSIÓN</th>
                                        <th>FUENTE</th>
                                        <th>DATOS</th>
                                        <th>CRITERIOS</th>
                                    </tr>
                                    <tr>
                                        <td width="100px" >
                                            <span style="float: left" v-for="item2 in item.conclusion" v-bind:key="item2">{{item2.label}}</span><br>
                                        </td>
                                        <td  width="150px">
                                            <div><span style="float: left; width: 100%" v-for="item2 in item.fuente" v-bind:key="item2">{{item2.label}}</span></div>
                                        </td>
                                        <td width="300px">
                                            <div v-for="item2 in item.datos" v-bind:key="item2">
                                                <div :title="item2.title">
                                                <v-checkbox  hide-details class="withoutStyle padre"  v-model="item2.value"></v-checkbox>
                                                {{item2.label}}
                                                </div>
                                            </div>
                                        </td>
                                        <td width="200px">
                                            <div style="float: left" v-if="item2.type==1" v-for="item2 in item.criterios" v-bind:key="item2">
                                                <div :title="item2.title">
                                                    <v-checkbox  hide-details class="withoutStyle padre" style="float: left" v-model="item2.value"></v-checkbox>
                                                    <div> {{item2.label}}</div>
                                                    <div style="float: left" v-if="item2.colorNumber!='undefined'" v-for="colorNumber in readColor(item2.colorNumber)" v-bind:key="colorNumber">
                                                        <span style="float: left" v-if="colorNumber.color=='R'" class="circleRed">{{colorNumber.number}}</span>
                                                        <span style="float: left" v-if="colorNumber.color=='Y'" class="circleYellow">{{colorNumber.number}}</span>
                                                        <span style="float: left" v-if="colorNumber.color=='N'" class="circleWhite">{{colorNumber.number}}</span>

                                                    </div>
                                                </div>
                                            </div>
                                            <br>
                                            <span style="float: right"  v-if="item2.type==0" v-for="item2 in item.criterios" v-bind:key="item2">{{item2.label}}</span><br>

                                        </td>
                                    </tr>
                                </table>
                            </div>

                        </v-flex>
                    </v-layout>

                        <div>Resultados</div>
                    <v-data-table
                            :headers="[ { text: 'Tabla' }, { text: 'Criterio' }]"
                            :items="criterioFinalMusculo.lista"
                            class="elevation-1"
                            hide-actions
                    >
                        <template slot="items" slot-scope="props">
                            <td class="text-xs-left">{{ props.item.title }}</td>
                            <td class="text-xs-left">
                                <div style="float: left" v-if="item2.type==1" v-for="item2 in props.item.criterios" v-bind:key="item2">
                                    <span  v-if="item2.value">{{item2.label}}</span>
                                </div>
                            </td>
                        </template>
                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                            No se han encontrado resultados para "{{ search }}".
                        </v-alert>
                    </v-data-table>
                    </div>

            <br>
            <!--            <span v-html="html"></span>-->
        </v-form>
        <div class="text-xs-center" v-if="this.criterioFinalMusculo!=null">
            <v-btn class="no-print" color="primary" @click="saveCriterioFinalMusculo" v-if="this.$store.state.routeSheet.status=='true'" dark>Guardar</v-btn>
        </div>
    </v-container>
</template>
<script>

    import CriterioFinalMusculo from "../../../../model/CriterioFinalMusculo";
    import PatientMonitoring from "../../../../model/PatientMonitoring";

    export default {
        props: ['company'],
        data() {
            return {
                html: null,
                listCriterioMusculoCf: [],
                radioGroup: 1,
                search: '',
                valid: false,
                requiredField: [v => !!v || 'Es requerido'],
                dialog: false,
                jobs: [],
                form:1,
                dialogSuccess: false,
                diagnosticos: [
                    {elemento: "Físicos", procesoPeligroso: "Temperatura elevada"},
                    {elemento: "Físicos", procesoPeligroso: "Temperatura baja"},
                    {elemento: "Físicos", procesoPeligroso: "Radiaciones ionizantes"},
                    {
                        elemento: "Biológicos",
                        procesoPeligroso: "Presencia de vectores (roedores, moscas, cucarachas)\t"
                    },
                    {elemento: "Biológicos", procesoPeligroso: "Bacterias, hongos, parásitos y virus"},
                    {elemento: "Biológicos", procesoPeligroso: "Alergenos de origen vegetal o animal"},
                    {elemento: "Biológicos", procesoPeligroso: "Consumo de alimentos no garantizados"},
                    {elemento: "Biológicos", procesoPeligroso: "Animales venenosos o ponzoñosos"},
                ],
                criterioFinalMusculo: null,
            };
        },
        methods: {
            readColor(item){
                let numbersAll = item.split('|')
                let retunList=[]
                for(let i=0; i<numbersAll.length; i++){
                    let data={number:numbersAll[i].substring(0, numbersAll[i].length-1),
                        color:numbersAll[i].substring(numbersAll[i].length-1,numbersAll[i].length )}
                    retunList.push(data)
                }
                return retunList
            },
            change(form){
                if(form==1){
                    // if(this.criterioFinalAuditivo.lista[0].datos[0].value && this.criterioFinalAuditivo.lista[0].datos[3].value){
                    //     this.criterioFinalAuditivo.lista[0].criterios[0].value=true
                    // }
                    // if(this.criterioFinalAuditivo.lista[0].datos[1].value && this.criterioFinalAuditivo.lista[0].datos[3].value){
                    //     this.criterioFinalAuditivo.lista[0].criterios[1].value=true
                    // }
                    // if(this.criterioFinalAuditivo.lista[0].datos[2].value && this.criterioFinalAuditivo.lista[0].datos[3].value){
                    //     this.criterioFinalAuditivo.lista[0].criterios[2].value=true
                    // }
                    //
                    // if(this.criterioFinalAuditivo.lista[1].datos[0].value &&
                    //     this.criterioFinalAuditivo.lista[1].datos[4].value &&
                    //     this.criterioFinalAuditivo.lista[1].datos[10].value &&
                    //     this.criterioFinalAuditivo.lista[1].datos[11].value
                    // ){
                    //     this.criterioFinalAuditivo.lista[1].criterios[0].value=true
                    // }
                    // if(this.criterioFinalAuditivo.lista[1].datos[1].value && this.criterioFinalAuditivo.lista[0].datos[3].value){
                    //     this.criterioFinalAuditivo.lista[1].criterios[1].value=true
                    // }
                    // if(this.criterioFinalAuditivo.lista[1].datos[2].value && this.criterioFinalAuditivo.lista[0].datos[3].value){
                    //     this.criterioFinalAuditivo.lista[1].criterios[2].value=true
                    // }
                    // if(this.criterioFinalAuditivo.lista[1].datos[2].value && this.criterioFinalAuditivo.lista[0].datos[3].value){
                    //     this.criterioFinalAuditivo.lista[1].criterios[3].value=true
                    // }


                }

            },

            newCriterioMusculoCf() {
                let d = new Date();
                let e = this.formatDate(d);
                this.criterioFinalMusculo = new CriterioFinalMusculo()
                this.criterioFinalMusculo.fecha = e
                this.listCriterioMusculoCf.push(this.criterioFinalMusculo)
            },

            saveCriterioFinalMusculo() {
                if (this.$refs.form.validate()) {
                    this.$store.state.patientMonitoringList=[]
                    if(this.criterioFinalMusculo.id!='' && this.criterioFinalMusculo.id!=null){
                        this.$store.dispatch('getPatientMonitoring',this.criterioFinalMusculo.id).then(response => {
                            this.$store.state.patientMonitoringOne.value=JSON.stringify(this.criterioFinalMusculo)
                            this.$store.dispatch('updatePatientMonitoring',this.$store.state.patientMonitoringOne).then(response => {
                                this.dialogSuccess = true
                                this.reloadData()
                            }, error => {
                                this.$store.state.progress = false
                                this.$store.state.dialogError = true
                            })
                        })
                    }else{
                        let monitoringNew=new PatientMonitoring()
                        monitoringNew.date=new Date()
                        monitoringNew.value=JSON.stringify(this.criterioFinalMusculo)
                        monitoringNew.form=18
                        monitoringNew.patientRouteSheet=this.$store.state.routeSheet
                        this.$store.dispatch('addPatientMonitoring',monitoringNew).then(response => {
                            this.dialogSuccess = true
                            this.reloadData()
                        }, error => {
                            this.$store.state.progress = false
                            this.$store.state.dialogError = true
                        })
                    }
                } else {
                    this.dialogError = true
                }
            },
            reloadData(){
                let data= new PatientMonitoring()
                data.form = 18
                data.patientRouteSheet = this.$store.state.routeSheet
                data.date= new Date()
                data.value= ""
                this.criterioFinalMusculo = null
                this.$store.dispatch('getPatientMonitoringByRouteSheetForm',data).then(response => {
                    this.listCriterioMusculoCf= []
                    for(let i=0; i<this.$store.state.patientMonitoringList.length;i++){
                        let anam=JSON.parse(this.$store.state.patientMonitoringList[i].value)
                        anam.id=this.$store.state.patientMonitoringList[i].id
                        this.listCriterioMusculoCf.push(anam)
                    }
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
            },
            formatDate(date) {
                var hours = date.getHours();
                var minutes = date.getMinutes();
                var seconds = date.getSeconds();
                var ampm = hours >= 12 ? 'pm' : 'am';
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                minutes = minutes < 10 ? '0' + minutes : minutes;
                var strTime = hours + ':' + minutes + ":" + seconds + ' ' + ampm;
                return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
            },



        },
        computed: {},
        created() {
            this.reloadData()
        },

    };
</script>

<style scoped>
    .circleYellow {
        height: 25px;
        width: 25px;
        display: table-cell;
        text-align: center;
        font-size:15px;
        vertical-align: middle;
        border-radius: 50%;
        background: yellow;
        float: left;
    }
    .circleRed {
        height: 25px;
        width: 25px;
        display: table-cell;
        text-align: center;
        font-size:15px;
        vertical-align: middle;
        border-radius: 50%;
        background: red;
        float: left;
    }
    .circleWhite {
        height: 25px;
        width: 25px;
        display: table-cell;
        text-align: center;
        font-size:15px;
        vertical-align: middle;
        border-radius: 50%;
        background: white;
        float: left;
    }
    .withoutStyle{
        all:revert;
    }
    .padre{
        border: 1px;
        display: inline-block;
        width: auto;
        margin: auto;
        text-align: left;
    }

    .container{
        max-width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/patient/monitoreo/criteriosFinales/MonitoreoMusculoCriteriosFinales.vue